<template>
  <div>
    <add-country :is-active.sync="isAdding" @changed="countryAdded" />
    <data-table
      title="Crypto Countries"
      :url="url"
      :headers="headers"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Country
        </v-btn>
      </template>
      <template slot="item.is_sending_country" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_sending_country">
          mdi-progress-check
        </v-icon>
        <v-icon color="error" v-else>
          mdi-progress-close
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddCountry from "./form";

export default {
  components: { AddCountry },
  data() {
    return {
      isAdding: false,
      url: "/api/v1/transactions/cryptoCountries",
      headers: {
        name: "Name",
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    countryAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails({ id }) {
      this.$router.push({ name: "crypto.countries.show", params: { id } });
    },
  },
};
</script>
